/* eslint-disable react/no-danger */
import React from 'react';
import type { Integration } from '@/types/Integration';
import integrationData from '../../../pages/IntegrationsPage/data/integrations';
import IntegrationHelp from './IntegrationHelp';
import IntegrationHelperStep from './IntegrationHelperStep';

export default function IntegrationHelperSteps({
  integrationId,
}: {
  integrationId: string;
}) {
  const integration: Integration | undefined =
    integrationData.integrations.find((i) => i.id === integrationId);

  if (!integration || !integration?.helperSteps) {
    return null;
  }

  const { helperSteps: { description, steps, title } = {}, name } = integration;

  return (
    <div className="rounded-lg border border-grey-300 bg-white">
      <div className="border-b border-grey-300 p-3 md:p-6">
        <h2 className="type-h3 md:type-h2">{title}</h2>
        {description && (
          <div
            className="type-body3 md:type-body1"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}
      </div>
      {steps?.map?.(({ description: stepDescription, id }, index) => (
        <IntegrationHelperStep
          key={id}
          description={stepDescription}
          stepNumber={index + 1}
        />
      ))}
      <IntegrationHelp name={name} />
    </div>
  );
}
